export const LANGUAGE_MAPPINGS: { [key: string]: { name: string; code: string }[] } = {
  en: [
    { name: 'English', code: 'en' },
    { name: 'Spanish', code: 'es' },
    { name: 'French', code: 'fr' },
    { name: 'German', code: 'de' },
    { name: 'Portuguese', code: 'pt' },
    { name: 'Japanese', code: 'ja' },
    { name: 'Russian', code: 'ru' },
    { name: 'Arabic', code: 'ar' },
    { name: 'Hindi', code: 'hi' },
    { name: 'Chinese', code: 'zh' }
  ],
  es: [
    { name: 'Inglés', code: 'en' },
    { name: 'Español', code: 'es' },
    { name: 'Francés', code: 'fr' },
    { name: 'Alemán', code: 'de' },
    { name: 'Portugués', code: 'pt' },
    { name: 'Japonés', code: 'ja' },
    { name: 'Ruso', code: 'ru' },
    { name: 'Árabe', code: 'ar' },
    { name: 'Hindi', code: 'hi' },
    { name: 'Chino', code: 'zh' }
  ],
  fr: [
    { name: 'Anglais', code: 'en' },
    { name: 'Espagnol', code: 'es' },
    { name: 'Français', code: 'fr' },
    { name: 'Allemand', code: 'de' },
    { name: 'Portugais', code: 'pt' },
    { name: 'Japonais', code: 'ja' },
    { name: 'Russe', code: 'ru' },
    { name: 'Arabe', code: 'ar' },
    { name: 'Hindi', code: 'hi' },
    { name: 'Chinois', code: 'zh' }
  ],
  de: [
    { name: 'Englisch', code: 'en' },
    { name: 'Spanisch', code: 'es' },
    { name: 'Französisch', code: 'fr' },
    { name: 'Portugiesisch', code: 'pt' },
    { name: 'Japanisch', code: 'ja' },
    { name: 'Russisch', code: 'ru' },
    { name: 'Arabisch', code: 'ar' },
    { name: 'Hindi', code: 'hi' },
    { name: 'Chinesisch', code: 'zh' }
  ],
  pt: [
    { name: 'Inglês', code: 'en' },
    { name: 'Espanhol', code: 'es' },
    { name: 'Francês', code: 'fr' },
    { name: 'Alemão', code: 'de' },
    { name: 'Português', code: 'pt' },
    { name: 'Japonês', code: 'ja' },
    { name: 'Russo', code: 'ru' },
    { name: 'Árabe', code: 'ar' },
    { name: 'Hindi', code: 'hi' },
    { name: 'Chinês', code: 'zh' }
  ],
  ja: [
    { name: '英語', code: 'en' },
    { name: 'スペイン語', code: 'es' },
    { name: 'フランス語', code: 'fr' },
    { name: 'ドイツ語', code: 'de' },
    { name: 'ポルトガル語', code: 'pt' },
    { name: '日本語', code: 'ja' },
    { name: 'ロシア語', code: 'ru' },
    { name: 'アラビア語', code: 'ar' },
    { name: 'ヒンディー語', code: 'hi' },
    { name: '中国語', code: 'zh' }
  ],
  ru: [
    { name: 'Английский', code: 'en' },
    { name: 'Испанский', code: 'es' },
    { name: 'Французский', code: 'fr' },
    { name: 'Немецкий', code: 'de' },
    { name: 'Португальский', code: 'pt' },
    { name: 'Японский', code: 'ja' },
    { name: 'Русский', code: 'ru' },
    { name: 'Арабский', code: 'ar' },
    { name: 'Хинди', code: 'hi' },
    { name: 'Китайский', code: 'zh' }
  ],
  ar: [
    { name: 'الإنجليزية', code: 'en' },
    { name: 'الإسبانية', code: 'es' },
    { name: 'الفرنسية', code: 'fr' },
    { name: 'الألمانية', code: 'de' },
    { name: 'البرتغالية', code: 'pt' },
    { name: 'اليابانية', code: 'ja' },
    { name: 'الروسية', code: 'ru' },
    { name: 'العربية', code: 'ar' },
    { name: 'الهندية', code: 'hi' },
    { name: 'الصينية', code: 'zh' }
  ],
  hi: [
    { name: 'अंग्रेज़ी', code: 'en' },
    { name: 'स्पेनिश', code: 'es' },
    { name: 'फ़्रेंच', code: 'fr' },
    { name: 'जर्मन', code: 'de' },
    { name: 'पुर्तगाली', code: 'pt' },
    { name: 'जापानी', code: 'ja' },
    { name: 'रूसी', code: 'ru' },
    { name: 'अरबी', code: 'ar' },
    { name: 'हिंदी', code: 'hi' },
    { name: 'चीनी', code: 'zh' }
  ],
  zh: [
    { name: '英语', code: 'en' },
    { name: '西班牙语', code: 'es' },
    { name: '法语', code: 'fr' },
    { name: '德语', code: 'de' },
    { name: '葡萄牙语', code: 'pt' },
    { name: '日语', code: 'ja' },
    { name: '俄语', code: 'ru' },
    { name: '阿拉伯语', code: 'ar' },
    { name: '印地语', code: 'hi' },
    { name: '中文', code: 'zh' }
  ],
  ur: [
    { name: 'انگریزی', code: 'en' },
    { name: 'ہسپانوی', code: 'es' },
    { name: 'فرانسیسی', code: 'fr' },
    { name: 'جرمن', code: 'de' },
    { name: 'پرتگالی', code: 'pt' },
    { name: 'جاپانی', code: 'ja' },
    { name: 'روسی', code: 'ru' },
    { name: 'عربی', code: 'ar' },
    { name: 'ہندی', code: 'hi' },
    { name: 'چینی', code: 'zh' }
  ],
  bn: [
    { name: 'ইংরেজি', code: 'en' },
    { name: 'স্প্যানিশ', code: 'es' },
    { name: 'ফরাসি', code: 'fr' },
    { name: 'জার্মান', code: 'de' },
    { name: 'পর্তুগিজ', code: 'pt' },
    { name: 'জাপানি', code: 'ja' },
    { name: 'রুশ', code: 'ru' },
    { name: 'আরবি', code: 'ar' },
    { name: 'হিন্দি', code: 'hi' },
    { name: 'চীনা', code: 'zh' }
  ],
  he: [
    { name: 'אנגלית', code: 'en' },
    { name: 'ספרדית', code: 'es' },
    { name: 'צרפתית', code: 'fr' },
    { name: 'גרמנית', code: 'de' },
    { name: 'פורטוגזית', code: 'pt' },
    { name: 'יפנית', code: 'ja' },
    { name: 'רוסית', code: 'ru' },
    { name: 'ערבית', code: 'ar' },
    { name: 'הינדי', code: 'hi' },
    { name: 'סינית', code: 'zh' }
  ]
};

export const NATIVE_LANGUAGES = [
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
  { code: 'fr', name: 'Français' },
  { code: 'de', name: 'Deutsch' },
  { code: 'pt', name: 'Português' },
  { code: 'ja', name: '日本語' },
  { code: 'ru', name: 'Русский' },
  { code: 'ar', name: 'العربية' },
  { code: 'hi', name: 'हिन्दी' },
  { code: 'zh', name: '中文' },
  { code: 'ur', name: 'اردو' },
  { code: 'bn', name: 'বাংলা' },
  { code: 'he', name: 'עברית' },
];

export const I_SPEAK_TEXT = {
  en: '🇺🇸 I speak English',
  es: '🇪🇸 Hablo español',
  fr: '🇫🇷 Je parle français',
  de: '🇩🇪 Ich spreche Deutsch',
  pt: '🇵🇹 Falo português',
  ja: '🇯🇵 私は日本語を話します',
  ru: '🇷🇺 Я говорю по-русски',
  ar: '🇸🇦 أنا أتحدث العربية',
  hi: '🇮🇳 मैं हिंदी बोलता हूँ',
  zh: '🇨🇳 我说中文',
  ur: '🇵🇰 میں اردو بولتا ہوں',
  bn: '🇧🇩 আমি বাংলা বলি',
  he: '🇮🇱 אני מדבר עברית'
};
